export const ARUBA_CRITERIA = {
  ARUBA: [
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Hardware Price Available?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Outsourcing",
      Questions: "Price per site Tier Available?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Licensing (# users, bandwidth, length of time, fixed)",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Hardware Availability",
      Model: "All",
      Questions: "How available is the necessary hardware? (Lead times)",
      Check: "Yes",
      Rating: 3,
      Notes: "Delivered 2-4 weeks from when the order is placed.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How is path selection determined? (jitter, latency, packet loss)",
      Check: "Yes",
      Rating: 3,
      Notes: "Loss, latency, jitter, MOS",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path selection be dynamically configured?",
      Check: "Yes",
      Rating: 3,
      Notes: "Using Business Intent Overlays (BIOS)",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "What path selection options can be set?",
      Check: "Yes",
      Rating: 3,
      Notes: "Different methods of link bonding are available.",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Can traffic be tagged based on rules?",
      Check: "Yes",
      Rating: 3,
      Notes: "Traffic is matched via Overlay ACL",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic be prioritized based on QOS or traffic tags?",
      Check: "Yes",
      Rating: 3,
      Notes: "Traffic is matched via Overlay ACL",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path load sharing be configured?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Different methods of link bonding are available. Also LACP is supported",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic steering be configured?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "By Overlay or fabric/internet or App Express Feature for targeted applications based on performance of breakout links",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution utilize traffic shaping to prioritize traffic for critical applications?",
      Check: "Yes",
      Rating: 3,
      Notes: "Yes, via Traffic classes tied to BIOs or targeted QOS policy",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution automatically select the best transport layer path based on performance metrics?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can the solution offer automated network failover?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution optimize access to popular SaaS applications?",
      Check: "Yes",
      Rating: 3,
      Notes: "App Express Feature",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there AI features for path selection?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "We look at the real time health of the paths and then react to it",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Does solution detect and respond to a link-layer brownout? How?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can solution detect and respond to an application brownout? How? ",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe the system's link selection capabilities. Are they available per application?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution monitor application reachability across multiple links?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe how the solution handles end-user connections (TCP flows) when traffic has to be moved from one link to another. Are sessions terminated or maintained?",
      Check: "Yes",
      Rating: 3,
      Notes: "Maintained",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution maintain flow symmetry and correct flows when asymmetry is detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Dynamic Path Control and First-packet iQ maintain symmetry. Adjusts routing policies to steer flows to symmetric paths.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "Can the solution support all types of WAN transport layer connection types?",
      Check: "Yes",
      Rating: 3,
      Notes: "Anything with an Ethernet handoff. We also sell a USB LTE dongle",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "All transport layer technologies are supported? Which ones are not?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions: "Are Dynamic Protocols supported? Please list.",
      Check: "Yes",
      Rating: 1,
      Notes: "BGP, OSPF",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "Does the solution operate without restrictions to any protocols?",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there any routing best practices for the product? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "At a high level, deterministic routing for HA deployments is best. Other details would need further discussion. ",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Outsourcing",
      Questions:
        "Can the Client control routes at the edge in the MSP scenario?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Depends on the level of RBAC the client has in Orchestrator/Downstream dynamic routing",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can the solution support multiple circuit carriers in active/active connection setup?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Can routing be controlled at the edge?",
      Check: "Yes",
      Rating: 3,
      Notes: "BGP",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does solution not require data-plane traffic to transit through single or multiple POPs (Point of Presence). Does solution operate without remote GW requirement?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "How does the solution integrate natively with existing MPLS WAN networks? Can the overlay and underlay be used simultaneously?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions: "Does the solution offer redundancy options (specify)? ",
      Check: "Yes",
      Rating: 1,
      Notes:
        "Edge-HA for Branches, traditional HA for larger sites using VRRP or deterministic routing",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is there no requirement for additional equipment besides the redundant SD-WAN appliance?",
      Check: "Yes",
      Rating: 3,
      Notes: "For Edge HA, no. Traditional would need edge switching",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Outsourcing",
      Questions: "What are failover and recovery speeds?",
      Check: "Yes",
      Rating: 1,
      Notes:
        "Circuit failover is per-packet. Routing failover based on protocol",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution include HA capabilities without requiring additional licensing? If not, please describe the licensing structure.",
      Check: "No",
      Rating: 1,
      Notes: "Additional licensing for HA appliance throughput",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution work without WAN-side switches and/or unique ISP addresses?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support fail-to-wire interfaces (multi-networking failover interfaces)?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can and how does the solution operate when it is unable to communicate with its controller or orchestration function (if any)?",
      Check: "Yes",
      Rating: 3,
      Notes: "Maintains traffic forwarding and path control autonomously.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support link capacity monitoring without flooding the link?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution maintain 100% of the WAN capacity in the event of a unit failure?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions: "Are there no geographic deployment restrictions?",
      Check: "No",
      Rating: 2,
      Notes: "Only to countries that are sanctioned/embargoed",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions:
        "What is the experience utilizing the solution in countries like China?",
      Check: "Yes",
      Rating: 2,
      Notes: "Keeping all China assets in a region with MPLS egress is best",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Is solution documentation access available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Are training options available?",
      Check: "Yes",
      Rating: 3,
      Notes: "No-cost self paced and/or instructor led training ",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer Zero Touch Provisioning?  If so, please describe the process.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Connect device to WAN or MGMT port, Orchestrator discovers,and can be onboarded manually or via YAML template.",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If ZTP is offered, does it operate without special DNS/DHCP records?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "No special requirements orther than internet access. True ZTP works only with DHCP wan links. Static WANs will require manual onboarding.",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions:
        "Does the solution offer integration with Legacy Infrastructures?",
      Check: "Yes",
      Rating: 3,
      Notes: "Peering with dynamic protocols or static routing.",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there a templating feature? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes: "YAML for ZTP, and device templates for settings",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions: "How many hours does a new site turn-up normally take?",
      Check: "Yes",
      Rating: 1,
      Notes:
        "Once familiar with the system and templating/setup maybe 20 minutes/1 hour depending on the complexity of the site and whether it's green or brown field",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no node limitations or restrictions?",
      Check: "Yes",
      Rating: 2,
      Notes: "1500 node limit per cloud Orchestrator instance",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no tunnel limitations or bandwidth?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "As of right now, the largest appliance tops out at 10Gb. Branch appliances range from 1 to 3Gb. Tunnel limits (In terms of counts) depend on how the BIOS are configured Hub and Spoke vs Mesh) and Region use.",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there no limitations on logical WAN interfaces? If so, please describe ",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "No deployment architecture options and limitations? (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 1,
      Notes:
        "Full mesh on all overlays can reach the max tunnel limit over a certain number of deployed devices. Rough estimate 350 deployed devices. Using regions and reducing the amount of mesh overlays can help if needed. ",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution support hub and spoke VPN topologies? Are multiple hubs supported?  (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect supports hub and spoke topologies with multiple hubs, leveraging Dynamic Path Control for optimization.",
    },
    {
      Criteria: "Scalability",
      Model: "Outsourcing",
      Questions:
        "If managed hardware solution, can the circuits be brought into existing hardware?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions:
        "Describe the steps for migrating a hybrid WAN (MPLS primary, Internet backup) solution into a SDWAN? Are there no disruptiions?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "No other scalability limitations?",
      Check: "No",
      Rating: 2,
      Notes: "60k max routes in Orchestrator table",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer a Single Pane of Glass?",
      Check: "Yes",
      Rating: 2,
      Notes: "For SDWAN yes. Right now SSE is another pane.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution allow management through the SSL portal? If yes does it support MFA and AD integration? SAML/SSO?",
      Check: "Yes",
      Rating: 3,
      Notes: "Yes. SAML. MFA supported",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer performance visibility?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the solution support Third-Party Application Integration?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does solution not require an Engineer to Node?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer API integration?",
      Check: "Yes",
      Rating: 3,
      Notes: "Rest API",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the API provide access to 100% of the features and functions of the solution?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is the solution's management platform self-hosted, or vendor provided?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "On-Prem(extra cost) or Aruba Hosted Orchestrator As A Service (no cost)",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If vendor-provided, what underlying platform is being used (GCP/AWS/Azure/etc.)? What's the support model? Are there no regional limitations?",
      Check: "Yes",
      Rating: 2,
      Notes: "AWS, TAC support. Can be deployed to different region if needed",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If not vendor-provided, how is it deployed/managed? How does it scale?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "On-Prem can be OVA, KVM. Can scale as needed provided hypervisor has recommended (reserved) resources",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Ease of Use? (new employee turn-up, vendor-specific terminology)",
      Check: "Yes",
      Rating: 3,
      Notes: "Very intuitive, easy to use.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Describe the upgrade process required to upgrade the solution?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Orchestrated Upgrades via EdgeConnect Orchestrator. Upgrades are conducted through the Aruba Orchestrator. Administrators push firmware updates to appliances in a controlled manner, either individually or in batches. Scheduled upgrades during maintenance windows ensure minimal disruption.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there generative AI capabilities for management?",
      Check: "No",
      Rating: 1,
      Notes: "Not at this time",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "What is the licensing model for the solution? Please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Bandwidth Based Core License, Boost (WANOP) and Advanced Security (IDS/IPS) add-ons",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the solution have an automation feature set?",
      Check: "Yes",
      Rating: 2,
      Notes: "Need Clarification",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer integration with other troubleshooting projects?",
      Check: "Yes",
      Rating: 2,
      Notes: "Need Clarification",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution support live packet capture for troubleshooting purposes?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect appliances support live packet capture through the EdgeConnect Orchestrator. Administrators can capture packets in real-time from specific appliances or links for detailed analysis.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the management solution support inline ticket creation?",
      Check: "No",
      Rating: 1,
      Notes:
        "Aruba EdgeConnect Orchestrator does not natively support inline ticket creation. However, it integrates with external ITSM tools (e.g., ServiceNow) for incident tracking and management.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Can network administrator use the solution to troubleshoot an end-user specific reported application performance problem?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Are there any native testing tools available for troubleshooting? If so, what are they?",
      Check: "Yes",
      Rating: 2,
      Notes: "Cli, traceroute, flows table, overall Orchestrator GUI",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer Artificial Intelligence capabilities? If so, please describe.",
      Check: "Yes",
      Rating: 2,
      Notes:
        "We identify poorly performing paths and move traffic to avoid those paths, AppExpress monitors health of key applications and moves them and reports. This removes the need for human troubleshooting, but still leaves reporting around circuits and providers for business review",
    },
    {
      Criteria: "Technical Support",
      Model: "All",
      Questions:
        "Does the solution offer 24/7 technical support with defined service levels for response and resolution time? ",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Insourcing/Co-Managed",
      Questions: "Is solution training available?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions:
        "How long is an estimated MTTR of a defective gateway appliance (what are support options)?",
      Check: "Yes",
      Rating: 3,
      Notes: "NBD and RMA options",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "What are the SLA support options available, list.",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "Are there financial implications for breaching SLA, explain?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are reporting capabilities available? Describe.",
      Check: "Yes",
      Rating: 3,
      Notes: "Built in via Orchestrator or via API for ingest by 3rd party",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "What types of data can be reported?",
      Check: "Yes",
      Rating: 2,
      Notes: "Tunnels, Appliance Data, Application Performance, etc",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can KPI data baselines be calculated automatically?",
      Check: "No",
      Rating: 1,
      Notes: "Need Clarification",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there network-wide insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Top talkers, Bandwidth Utilization, Network performance, Flow count, Latency, Packet Loss, Data reduction",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there site-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Top talkers, Bandwidth Utilization, Network performance, Flow count, Latency, Packet Loss, Data reduction",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there device-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Top talkers, Bandwidth Utilization, Network performance, Flow count, Latency, Packet Loss, Data reduction",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are there link-level performance metrics available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect supports link-level performance monitoring through its Orchestrator. Metrics such as latency, jitter, packet loss, and link utilization are available to ensure transport layer performance.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there application-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Top talkers, Bandwidth Utilization, Network performance, Flow count, Latency, Packet Loss, Data reduction",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are performance metrics available for sub-applications (e.g. Gmail vs. all Google apps)?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are full performance monitoring capabilities available for traffic using direct-to-internet paths?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there end-user insights available? If so, please describe.",
      Check: "Yes",
      Rating: 1,
      Notes: "Need Clarification, yes with NAC for basic user activity",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Can the data be reported in a visually appealing format? (Graphs, illustrations, etc.)",
      Check: "Yes",
      Rating: 3,
      Notes: "The built in reporting engine can produce a number of results",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can data reporting be filtered by different time frames?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Is this solution application-aware?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can traffic be dynamically steered based on real-time network performance and application priority?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application bandwidth be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application latency be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application jitter be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application loss be detected?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can the solution throttle at the application level (similar to application-based QoS policy)?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Can policies be built based on tagged traffic?",
      Check: "Yes",
      Rating: 3,
      Notes: "Busines Intent Overlays",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer granular security policies?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there an application policy enforcement feature?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer monitoring and policy control based on user identity and user group membership?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution incorporate DLP mechanisms?",
      Check: "No",
      Rating: 1,
      Notes: "Part of the SSE not SD-WAN",
    },
    {
      Criteria: "Security Policy",
      Model: "All",
      Questions: "Does the solution allows login based on SSO?",
      Check: "Yes",
      Rating: 3,
      Notes: "Orchestrator integrates with IDPs",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Does the solution offer protection for the SD-WAN edge devices? If so, please describe.",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Native Zone Based Firewall, IDS/IPS Add-On License. Devices hardended by default. ",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Describe how secret key material is protected throughout the entire provisioning and de-provisioning lifecycle?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect employs secure key exchange mechanisms (e.g., TLS or IPsec) for provisioning. Secret keys are stored encrypted and de-provisioning invalidates key material, ensuring no reuse or unauthorized access.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "If a unit is lost or compromised, how is key information protected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect encrypts all stored key material. If a device is lost or compromised, administrators can revoke keys via the Orchestrator, rendering the device unable to access the SD-WAN network.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "What mechanisms are in place to prevent a compromised unit from gaining network access?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect uses unique device IDs and encrypted key material. If a device is compromised, its keys are revoked via the Orchestrator, preventing it from establishing tunnels or accessing the network.",
    },
    {
      Criteria: "Secure Edge",
      Model: "Insourcing/Co-Managed",
      Questions:
        "What types of NAT are supported?  (Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution meet U.S. encryption import/export guidelines and laws?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can source and destination Network Address Translation (NAT) be configured?  -(Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "What types of NAT are supported?  (Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution use a single shared encryption key or multiple encryption keys between tunnels?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Are tunnel encryption keys rotated? How often are tunnel keys rotated?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect performs automated encryption key rotation for all tunnels. The default rotation interval is one hour, ensuring secure, ephemeral keys for each session.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution support latest standard for end-to-end traffic encryption? (AES- 256)",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution have stateful firewalling? ",
      Check: "Yes",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer Deep Packet Inspection?",
      Check: "Yes",
      Rating: 1,
      Notes: "DPI can be enabled with Firewall Protection Profiles",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer an IDS & IPS feature?",
      Check: "Yes",
      Rating: 1,
      Notes: "Add-on License",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer antivirus and antimalware protection?",
      Check: "No",
      Rating: 1,
      Notes: "Part of the SSE not SD-WAN",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Can security rules be put in place for layer 4-7?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Are application/layer 7 rules supported?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can custom applications be defined based on URL or domain and subdomain? (E.g. example.com, crm.example.com)",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Do custom applications receive 100% of the feature/functionality as built-in/system applications?",
      Check: "No",
      Rating: 1,
      Notes: "NA",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Does the solution have the ability to segment traffic?",
      Check: "Yes",
      Rating: 1,
      Notes: "VRF/Zone Based Firewall",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Describe how traffic may be separated for different device types and pools?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect supports segmentation through overlay tunnels and VLANs. Traffic can be separated by defining VLANs for device types or application pools, with path isolation maintained across the SD-WAN fabric.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "When traffic separation is in place, is a different encryption key used for VPN tunnels?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect assigns unique encryption keys to each overlay tunnel. When traffic is segmented by VLANs or policies, the corresponding tunnels are secured with different keys to maintain isolation.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Is the network segmentation capability PCI-compliant?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Aruba EdgeConnect supports PCI compliance through VLAN-based segmentation and encrypted overlay tunnels. It provides traffic isolation and security controls required to meet PCI DSS standards.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "How does segmentation integrate with legacy Infrastructure?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Does SD-WAN solution capable to secure IoT devices? Is there a need for additional hardware to secure IoT?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "DDOS Protection",
      Model: "Co-Managed/Outsourcing",
      Questions: "How is DDOS Protection Supported/Achieved",
      Check: "Yes",
      Rating: 1,
      Notes:
        "By default, only incoming traffic allowed  is from IPSEC UDP 12000-120010, and only from peers that are known to the fabric. Custom DOS threshholds can be set by enabling Firewall Protection Profiles",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Is the device FIPS Compliant?",
      Check: "Yes",
      Rating: 1,
      Notes: "Only certain software trains are FIPs compliant, 140-2 level 1",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Are there any other Compliance Standards?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
  ],
};
